<template>
  <section>
    <Container>
      <h2 class="py-8 text-center text-3xl font-medium text-white lg:text-left lg:text-4xl">
        {{ title }}
      </h2>

      <div class="grid grid-cols-1 gap-8 pb-16 pt-4 md:grid-cols-2 lg:grid-cols-3 lg:pb-24">
        <ButtonSocial
          v-for="(link, i) in social"
          :key="i"
          :icon="link.icon as SocialType"
          :href="link.url"
          :label="`Outfit7 @ ${link.title}`"
          @click="handleClick(link.title)" />
      </div>
    </Container>
  </section>
</template>

<script setup lang="ts">
  /**
   * List of social links with a title
   *
   * Social links are loaded from the social navigation menu, so they
   * are consistent across the site.
   */
  import { useRoute } from 'vue-router'
  import { useNuxtApp } from '#imports'

  import social from '../../content/navigation/social.json'
  import type { SocialType } from '../../models/button'

  type SocialLinksProps = {
    title: string
  }

  defineProps<SocialLinksProps>()

  const { $event } = useNuxtApp()
  const route = useRoute()

  function handleClick(linkTitle: string) {
    if (route.path.includes('contact-us')) {
      return $event('Link', { props: { 'Contact us page': linkTitle } })
    }
    if (route.path.includes('our-work')) {
      return $event('Link', { props: { 'Our work page': linkTitle } })
    }
  }
</script>
